/**
 * Created by Jerker Nord on 2021-01-28.
 */
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {Possessed} from "../Possessed";
import {gsap} from "gsap"
import {WinPresentation} from "./presentations/WinPresentation";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {APIFeatureBetEventData} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetEventData";

export class PossessedIdleNormalPresentation implements FlowStatePresentation {
    private tl:gsap.core.Timeline;
    private xBetEnableTL:gsap.core.Timeline;

    constructor() {
        this.tl = gsap.timeline();
        this.xBetEnableTL = gsap.timeline();
        Possessed.apiPlugin.events.on(APIEvent.BET, (data: APIFeatureBetEventData) => this.skip(data));
    }

    public start(flowStateController:FlowStateController) {
        flowStateController.setSkipCallback(() => this.onComplete(flowStateController))

        const easterEggAllowed = Possessed.foregroundElements.logo.visible;
        Possessed.easterEggView.clickArea.interactive = false;

        this.xBetEnableTL = gsap.timeline()
            .add(() => {})
            .add(() => {
                //Exorcism.xBetView.show();
                if(!Possessed.apiPlugin.isReplay && !Possessed.apiPlugin.freeBets.hasFreeBets()) {
                    //Possessed.xBetView.setButtonEnabled(true);
                    //Possessed.xBetView.playIdleAnimation();
                    if(easterEggAllowed) {
                        Possessed.easterEggView.clickArea.interactive = true;
                    }
                }
            }, '>0.2');

        if(Possessed.model.gameData && Possessed.model.gameData.brokeTheBank) {
          const tl = gsap.timeline();
          tl.add(Possessed.winCounter.show(Possessed.model.gameData.accumulatedRoundWin));
          this.tl = tl;
        } else if (Possessed.model.gameData && Possessed.model.gameData.betWayWins.length > 0) {
            const tl = gsap.timeline();
            tl.add(()=>{}, ">0.7");
            tl.add(WinPresentation.playWinToggle());
            tl.add(()=>{}, ">1");
            tl.repeat(-1);
            this.tl = tl;
        }
    }

    private onComplete(flowStateController:FlowStateController) {
        //this.tl.progress(1);
        //this.tl.kill();

        Possessed.reelView.winFireView.clearAllSpines();
        flowStateController.finish();
    }

    private skip(data:APIFeatureBetEventData) {
        this.xBetEnableTL.kill();
        this.tl.kill();
        Possessed.reelView.getAllVisibleSymbols().filter(s => s.name != "S").forEach(sym => sym.resetState());
    }
}